import generateId from 'App/helpers/misc/generateId'
import uploadImage from 'App/helpers/misc/uploadImage/uploadImage'
import gql from 'graphql-tag'
import fireEvent from 'App/helpers/globalEvents/fireEvent'

export default async function({client, mutate, userId, text, image, conversationId}) {
  if (!text && !image) return
  const contentType = text ? 'text' : 'image'

  const messageId = generateId()

  if (image) {
    const reader = new FileReader()
    reader.onload = function(event) {
      fireEvent('messageSent', {
        _id: messageId,
        conversationId,
        image: {
          isSending: true,
          url: event.target.result
        },
        contentType
      })
    }
    reader.readAsDataURL(image)
  } else {
    fireEvent('messageSent', {
      _id: messageId,
      conversationId,
      text,
      contentType
    })
  }

  if (image) {
    const result = await uploadImage(client, image)
    image = {_id: result}
  }

  await mutate({
    mutation: gql`
      mutation sendMessage(
        $messageId: ID
        $conversationId: ID
        $text: String
        $image: ImageInput
        $sentByAdminId: ID
      ) {
        sendMessage(
          messageId: $messageId
          conversationId: $conversationId
          text: $text
          image: $image
          sentByAdminId: $sentByAdminId
        ) {
          _id
          conversationId
          text
          image {
            _id
            url
          }
          sentByAdminId
        }
      }
    `,
    variables: {
      messageId: messageId,
      conversationId: conversationId,
      text: text,
      image: image,
      sentByAdminId: userId
    },
    refetchQueries: ['activeConversationMessages']
  })
}
